// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FileItem} from '../containers/FileItem';
import { Loading } from '../containers/Loading';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, FormGroup, Form, FormText, Input, FormFeedback } from 'reactstrap';
import {validateProductFiles} from '../../validation/ProductValidation';
import { getAllCategories, getAllProductTypes } from '../state/actions/CategoryActions';
import { getAllSegments } from '../state/actions/SegmentActions';

//COMPONENT

class ProductCreationModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            type: '',
            category: '',
            subcategory: '',
            allProductTypes: [],
            allProductCategories: [],
            allSegments: [],
            subcategories: [],
            selectedSegments: {},
            typeValid: true,
            categoryValid: true,
            subcategoryValid: true,
            isValid: true,
            invalidMessage: '',
            files: [],
            metadata: {},
            filesToUpload: []
        };

        this.createProduct = this.createProduct.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.dismissModal = this.dismissModal.bind(this);
        this.validateInput = this.validateInput.bind(this);
        this.addNewFiles = this.addNewFiles.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.categoryChange = this.categoryChange.bind(this);
        this.typeChange = this.typeChange.bind(this);
        this.validateSelections = this.validateSelections.bind(this);
        this.subcategoryChange = this.subcategoryChange.bind(this);
        this.getIDFromName = this.getIDFromName.bind(this);
        this.selectedSegmentsChanged = this.selectedSegmentsChanged.bind(this);
    }

    componentDidMount(){
        this.props.getAllCategories();
        this.props.getAllProductTypes();

        this.setState({allSegments: this.props.allSegments});
    }

    componentDidUpdate(prevProps){
        if(this.props.allProductCategories != prevProps.allProductCategories){

            this.setState({allProductCategories: this.props.allProductCategories});

            if(this.props.allProductCategories.length == 1){

                let subcategoriesWithIds = Object.keys(this.props.allProductCategories[0].subcategories).map((subcategoryId) => { 
                    let subcategoryItem = this.props.allProductCategories[0].subcategories[subcategoryId];
                    subcategoryItem['id'] = subcategoryId;
                    return subcategoryItem;
                });
                
                this.setState({
                    category: this.props.allProductCategories[0].id,
                    subcategories: subcategoriesWithIds
                });
            }
        }

        if(this.props.allSegments != prevProps.allSegments){
            this.setState({allSegments: this.props.allSegments});
        }

        if(this.props.allProductTypes != prevProps.allProductTypes){
            this.setState({allProductTypes: this.props.allProductTypes});
        }
    }

    onDrop(accepted, rejected) {
        if (rejected.length == 0) {
            let files = this.addNewFiles(accepted);
            this.setState({
                files: files,
                isValid: true,
                invalidMessage: ''
            });
            this.validateInput(files);
        } else {
            let errorMessage = 'Unsupported file' + (rejected.length > 1 ? 's: ' : ': ') + rejected.map(file => file.name).join(', ');
            this.setState({
                isValid: false,
                invalidMessage: errorMessage
            });
        }
    }

    addNewFiles(newFiles) {
        var newUniqieFiles = [];
        let existingFiles = this.state.files;

        for(let file of newFiles) {
            if(!existingFiles.map((file) => file.name).includes(file.name)){
                newUniqieFiles.push(file);
            }
        }

        return existingFiles.concat(newUniqieFiles);
    }

    validateInput(files){
        validateProductFiles(files, (validityData) => {
            this.setState({
                isValid: validityData.isValid,
                invalidMessage: validityData.errorMessage,
                metadata: validityData.metadata,
                filesToUpload: validityData.filesToUpload
            });
        });
    }

    validateSelections(){
        this.setState({
            categoryValid: this.state.category != '' && this.state.category != null,
            typeValid: this.state.type != '' && this.state.type != null,
            subcategoryValid: this.state.subcategory != '' && this.state.subcategory != null
        });
    }

    createProduct(){
        this.validateSelections();
        if (this.state.isValid && this.state.filesToUpload.length > 0 && this.state.metadata !== {} && this.state.typeValid && this.state.categoryValid  && this.state.subcategoryValid) {
            let metaData = this.state.metadata;
            metaData.type = this.state.type;
            metaData.category = this.state.category;
            metaData.subcategory = this.state.subcategory;
            metaData.segments = this.state.selectedSegments;
            this.props.uploadProduct(metaData, this.state.filesToUpload);
            this.setState({files: []});
        }
    }

    subcategoryChange(e){
        this.setState({subcategory: this.getIDFromName(e.target.value, this.state.subcategories)});
    }

    categoryChange(e){
        this.setState({category: this.getIDFromName(e.target.value, this.state.allProductCategories)});

        if(e.target.value != ''){

            let subcategoriesWithIds = Object.keys(this.state.allProductCategories[e.target.value].subcategories).map((subcategoryId) => { 
                let subcategoryItem = this.state.allProductCategories[e.target.value].subcategories[subcategoryId];
                subcategoryItem['id'] = subcategoryId;
                return subcategoryItem;
            });

            this.setState({subcategories: subcategoriesWithIds});
        }
    }
    
    typeChange(e){
        this.setState({type: this.getIDFromName(e.target.value, this.state.allProductTypes)});
    }

    selectedSegmentsChanged(e){
        var options = e.target.options;
        var value = {};
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                let id = this.getIDFromName(options[i].value, this.state.allSegments);
                if(id != undefined && id != null){
                    value[id] = true;
                }
            }
        }

        this.setState({selectedSegments: value});
    }

    getIDFromName(name, array) {
        if(array != undefined && array != null){
            for(let item of array) {
                if ( item.name == name) {
                    return item.id;
                }
            }
        }
        return null;
    }

    dismissModal(){
        this.setState({
            files: [],
            isValid: true,
            invalidMessage: ''
        });

        this.props.toggleCreateModal();
    }

    removeFile(filename){
        let filteredFiles = this.state.files.filter(function (i) {
            return i.name !== filename;
        });

        this.setState({
            files: filteredFiles
        });

        this.validateInput(filteredFiles);
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle} >
                    <ModalHeader toggle={this.toggle}>Add Product</ModalHeader>
                    <ModalBody>
                        {(!this.props.uploadingProducts && this.props.fetchedAllProductCategories) && 
                            <div>
                                <Form>
                                    {Object.keys(this.state.allProductCategories).length > 1 &&  
                                        <FormGroup>
                                            <Label for="typeSelect">Category</Label>
                                            <Input invalid={!this.state.categoryValid} type="select" name="select" id="typeSelect" onChange={this.categoryChange}>
                                                <option value="">Select category...</option>
                                                {this.state.allProductCategories.map((category) => {
                                                    return(<option key={category.id}>{category.name}</option>);
                                                })}
                                            </Input>
                                            <FormFeedback>{this.state.invalidNameMessage}</FormFeedback>
                                        </FormGroup>
                                    } 

                                    <FormGroup>
                                        <Label for="typeSelect">{this.state.allProductCategories.length > 1 ? 'Subcategory' : 'Category'}</Label>
                                        <Input invalid={!this.state.subcategoryValid} type="select" name="select" id="typeSelect" onChange={this.subcategoryChange} disabled={this.state.category == ''}>
                                            <option value=""> {this.state.allProductCategories.length > 1 ? 'Select subcategory...' : 'Select category...'} </option>
                                            {this.state.subcategories.map((subcategory) => {
                                                return(<option key={subcategory.id}>{subcategory.name}</option>);
                                            })}
                                        </Input>
                                        <FormFeedback>{this.state.invalidNameMessage}</FormFeedback>
                                    </FormGroup>

                                    <FormGroup>
                                        <Label for="typeSelect">Type</Label>
                                        <Input invalid={!this.state.typeValid} type="select" name="select" id="typeSelect" onChange={this.typeChange}>
                                            <option value="">Select Type...</option>
                                            {this.state.allProductTypes.map((type) => {
                                                return(<option  key={type.id}>{type.name}</option>);
                                            })}
                                        </Input>
                                        <FormFeedback>{this.state.invalidNameMessage}</FormFeedback>
                                    </FormGroup>

                                    <FormGroup>
                                        <Label for="typeSelect">Associated Segments</Label>
                                        <Input invalid={!this.state.typeValid} multiple type="select" name="select" id="typeSelect" onChange={this.selectedSegmentsChanged}>
                                            {this.state.allSegments.map((segment) => {
                                                return(<option  key={segment.id}>{segment.name}</option>);
                                            })}
                                        </Input>
                                        <FormFeedback>{this.state.invalidNameMessage}</FormFeedback>
                                    </FormGroup>
                                    
                                    <FormGroup>
                                        <Label for="productName">Upload Files</Label>
                                        <div >
                                            <Dropzone className="dropzone" onDrop={this.onDrop} accept="image/jpeg, image/png, .json, .usdz, .scn, .dae, .obj">
                                                <p className="noselect">Drag and drop files here, or click to select files to upload.</p>
                                            </Dropzone>
                                        </div>
                                    </FormGroup>
                                    {(this.state.files.length > 0 || this.state.invalidMessage !== '') && 
                                        <FormGroup >
                                            <Label for="equipmentFiles">Files</Label>
                                            <FormText color="danger">
                                                {this.state.invalidMessage}
                                            </FormText>
                                            {this.state.files.map((file) => {
                                                return(
                                                    <FileItem key={file.name} name={file.name} size={file.size} removeFile={this.removeFile} />
                                                );
                                            })}
                                        </FormGroup>
                                    }
                                </Form>
                            </div>
                        }
                        {(this.props.uploadingProducts || this.props.fetchingAllProductCategories) && 
                            <div className="file-uploading-container">
                                <Loading/>
                            </div>
                        }
                    </ModalBody>
                    {!this.props.uploadingProducts && 
                        <ModalFooter>
                            <Button className="button" color="secondary" onClick={this.dismissModal}>Cancel</Button>
                            <Button className="button" color="primary" onClick={this.createProduct}>Create</Button>{' '}
                        </ModalFooter>
                    }  
                </Modal>
            </Fragment>
        );
    }
}

ProductCreationModal.propTypes = {
    history: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggleCreateModal: PropTypes.func.isRequired,
    validateProductFiles: PropTypes.func.isRequired,
    uploadProduct: PropTypes.func.isRequired,
    uploadedProducts: PropTypes.bool.isRequired,
    uploadingProducts: PropTypes.bool.isRequired,
    failedProducts: PropTypes.bool.isRequired,
    getAllCategories: PropTypes.func.isRequired,
    allProductCategories: PropTypes.array.isRequired,
    allProductTypes: PropTypes.array.isRequired,
    fetchingAllProductCategories: PropTypes.bool.isRequired,
    fetchedAllProductCategories: PropTypes.bool.isRequired,
    failedAllProductCategories: PropTypes.bool.isRequired,
    fetchingAllProductTypes: PropTypes.bool.isRequired,
    fetchedAllProductTypes: PropTypes.bool.isRequired,
    failedAllProductTypes: PropTypes.bool.isRequired,
    getAllProductTypes: PropTypes.func.isRequired,
    getAllSegments: PropTypes.func.isRequired,
    fetchingAllSegments: PropTypes.bool.isRequired,
    fetchedAllSegments: PropTypes.bool.isRequired,
    failedAllSegments: PropTypes.bool.isRequired,
    allSegments: PropTypes.array.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const {fetchingAllProductCategories, fetchedAllProductCategories, failedAllProductCategories,  allProductCategories, allProductTypes, fetchingAllProductTypes, fetchedAllProductTypes, failedAllProductTypes } = state.categoryReducer;
    const { uploadedProducts, uploadingProducts, failedProducts } = state.productReducer;
    const { allSegments, fetchingAllSegments, fetchedAllSegments, failedAllSegments } = state.segmentReducer;
    return { uploadedProducts, uploadingProducts, failedProducts, fetchingAllProductCategories, fetchedAllProductCategories, failedAllProductCategories,  allProductCategories, allProductTypes, 
        fetchingAllProductTypes, fetchedAllProductTypes, failedAllProductTypes, allSegments, fetchingAllSegments, fetchedAllSegments, failedAllSegments  };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ validateProductFiles, getAllCategories, getAllProductTypes, getAllSegments }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductCreationModal));

// EXPORT COMPONENT
export { hoc as ProductCreationModal };


// WEBPACK FOOTER //
// ./src/components/modals/ProductCreationModal.js